import { render, staticRenderFns } from "./districtDashboard.vue?vue&type=template&id=c8b7e8de&scoped=true"
import script from "./districtDashboard.vue?vue&type=script&lang=js"
export * from "./districtDashboard.vue?vue&type=script&lang=js"
import style0 from "./districtDashboard.vue?vue&type=style&index=0&id=c8b7e8de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b7e8de",
  null
  
)

export default component.exports